// client/src/components/shared/Navigation.tsx

import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import SidebarNavigation from "./SidebarNavigation";
import TopNavBar from "./TopNavBar";
import Footer from "./Footer";
import "../../assets/styles/shared.css"; // Optional global shared CSS

const Navigation: React.FC = () => {
  const location = useLocation();
  const isCompeteDashboard = location.pathname.includes('/app/compete/dashboard');

  return (
    <div className="app-layout">
      <Header />
      <div className="main-content">
        {!isCompeteDashboard && (
          <SidebarNavigation 
            showQuickActions={true} 
            hideLearningSections={false}
          />
        )}
        <div className={`content-area ${isCompeteDashboard ? 'full-width' : ''}`}>
          {!isCompeteDashboard && <TopNavBar />}
          <main className="page-content">
            {/* Nested routes will render here */}
            <Outlet />
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Navigation;
